module.exports = __webpack_public_path__ + "fonts/dace493d-2c1a-478b-a98e-0e73f323a856.ca13b2f.woff2";